<template>
  <div class="item-component">
    <div class="s-item-title">
      <h4 class="chart-title">
        <i class="el-icon-s-grid"></i>
        缴费统计人数
      </h4>
    </div>
    <chart-twelve style="height: 90%" :value="chartData"></chart-twelve>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ChartTwelve from "../charts/chart12";
export default {
  components: {
    ChartTwelve,
  },
  data() {
    return {
      chartData: [],
      enrollmentYear: "", // 入学年份
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE", "_CURRENTYEAR"]),
  },
  created() {
    this.enrollmentYear = this._CURRENTYEAR[0].value;
    // this.getFinanceData();
  },
  mounted() {},
  methods: {
    getFinanceData() {
      // let params = { enrollmentYear: this.enrollmentYear };
      this.$http
        .get("/finance/statistics/getNumByCollege")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            // console.log(res);
            this.chartData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
